import { render } from "./index.vue?vue&type=template&id=c1e51b46"
const script = {}

import exportComponent from "D:\\web\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__